import { provideAppInitializer, inject, ErrorHandler, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";

import { ConfigService } from "@services/config.service";
import { AuthService } from "@services/auth.service";
import { CustomErrorHandler } from "@utils/custom-error-handler";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { AppDateAdapter, APP_DATE_FORMATS } from "./app/interfaces/format-datepicker";
import { OAuthStorage, OAuthModule } from "angular-oauth2-oidc";
import { DatePipe, UpperCasePipe, LowerCasePipe, TitleCasePipe, registerLocaleData } from "@angular/common";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from "@angular/material/form-field";
import { provideNgxMask } from "ngx-mask";
import { provideHttpClient, withXhr, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { appInterceptorFn } from "./app/app.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { appRoutes } from "./app/app.routes";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PopoverModule } from "ngx-bootstrap/popover";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPaginationModule } from "ngx-pagination";
import { MatStepperModule } from "@angular/material/stepper";
import { ToastrModule } from "ngx-toastr";
import { NgSelectModule } from "@ng-select/ng-select";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";

import localePt from '@angular/common/locales/pt';
import { provideRouter } from "@angular/router";
registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(appRoutes),
        importProvidersFrom(
            BrowserAnimationsModule,
            FormsModule, 
            ReactiveFormsModule, 
            PopoverModule, 
            NgxSpinnerModule, 
            NgxPaginationModule, 
            MatStepperModule, 
            ToastrModule.forRoot({ timeOut: 30000, preventDuplicates: true }), 
            NgSelectModule, 
            ReactiveFormsModule,
            BsDropdownModule, 
            MatFormFieldModule,
            MatInputModule, 
            MatTooltipModule, 
            MatDatepickerModule, 
            MatNativeDateModule, 
            MatExpansionModule, 
            MatIconModule, 
            OAuthModule.forRoot({ resourceServer: {
                allowedUrls: ['/apiconnect'],
                sendAccessToken: true,
            } }), 
            MatSlideToggleModule, 
            MatMenuModule, 
            MatSelectModule, 
            NgxMatSelectSearchModule, 
            MatOptionModule, 
            MatProgressBarModule, 
            MatGridListModule, 
            MatDialogModule, 
            MatButtonModule, 
        ),
        provideAppInitializer(() => {
            const configService = inject(ConfigService);
            const authService = inject(AuthService);
            return configService.loadConfig().then(() => authService.init());
        }),
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR'
        },
        {
            provide: DateAdapter,
            useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'pt-BR'
        },
        {
            provide: OAuthStorage,
            useFactory: () => sessionStorage
        },
        DatePipe,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                floatLabel: 'auto'
            }
        },
        UpperCasePipe,
        LowerCasePipe,
        TitleCasePipe,
        provideNgxMask(),
        provideHttpClient(withXhr(), withInterceptors([appInterceptorFn]), withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
